<input
  #input
  type="text"
  readonly
  (focus)="onCopyInputFocus($event)"
  [value]="text"
/>
<ab-icon name="copy-clipboard" (click)="copyToClipboard()"></ab-icon>
